<template>
  <div>
    <div v-for="(pocItem, index) in proofOfConcepts" :key="index">
      <div v-if="pocItem.kind === 'shell'">
        <div v-for="(codeBlock, codeIndex) in pocItem.code" :key="codeIndex">
          <div v-if="codeBlock.file">
            <strong>File: {{ codeBlock.file }}</strong>
          </div>
          <div v-for="(line, lineIndex) in codeBlock.lines" :key="lineIndex">
            <pre
              v-highlightjs="line.content"
              class="hljs poc-code-line"
              :class="leftBorderColorClass(severity)"
            ><code class="bash"></code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VulnPOC',
  props: {
    proofOfConcepts: {
      type: Array,
      required: true,
    },
    severity: {
      type: String,
      required: true,
    },
  },
  methods: {
    leftBorderColorClass(severity) {
      const severityColors = {
        low: 'green',
        medium: 'yellow',
        high: 'red',
      };
      return severityColors[severity];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/fonts';
@import '../../assets/css/variables';

pre.poc-code-line {
  margin: 0;
  border-left: 4px solid gray;
  background: #f8fafc;
  padding-left: 40px;

  &.green {
    border-color: $low-vulnerability-color;
  }

  &.yellow {
    border-color: $medium-vulnerability-color;
  }

  &.red {
    border-color: $high-vulnerability-color;
  }

  code {
    padding: 1px 0;
    color: #021631;
    font-size: 14px;
    line-height: 25px;
    text-shadow: none;
  }
}
</style>
